<template>
  <div class="activate">
    <!-- <div class="form-container"> -->
    <!-- E6 Logo -->
    <!-- <div class="flex justify-center">
        <img class="logo" src="../assets/e6golf_connect_black@3x.png" />
      </div> -->

    <!-- Activation message -->
    <!-- <div v-if="activated && !activating">
        <div class="text-h6 flex justify-center text-h2">Thank You!</div>
        <p class="flex justify-center">Your account has successfully been activated.</p>
        <p class="flex justify-center">You will be redirect in {{ timer }}</p>
      </div>

      <div v-if="!activated && !activating">
        <div class="flex justify-center text-h2">Sorry!</div>
        <p class="flex justify-center">
          An invalid token was provided to us. Try logging in and sending yourself a new activation
          link.
        </p>
        <p class="flex justify-center">You will be redirect in {{ timer }}</p>
      </div> -->

    <!-- Spacers and dividers -->
    <!-- <div class="spacer"></div>
      <v-divider></v-divider>
      <div class="spacer"></div> -->

    <!-- Redirect -->
    <!-- <router-link to="/login">
        <v-btn block type="submit" secondary>go to login</v-btn>
      </router-link>
    </div> -->

    <v-container class="activate-container">
      <v-row no-gutters class="login-box" justify="center">
        <v-col cols="12">
          <div class="flex justify-center">
            <img class="logo" data-cy="logo" :src="E6Logo" />
          </div>
        </v-col>

        <v-col cols="12" sm="8">
          <v-sheet class="connect-login">
            <div v-if="loading" class="progress">
              <pulse-loader color="#ba2127" size="2rem"></pulse-loader>
            </div>

            <div v-if="!loading" class="white--text text-uppercase text-center">
              <div v-if="activated && !activating">
                <div class="text-h6 flex justify-center text-h2">Thank You!</div>
                <p class="flex justify-center">Your account has successfully been activated.</p>
                <p class="flex justify-center">You will be redirected in {{ timer }}</p>
              </div>
              <div v-if="!activated && !activating">
                <div class="flex justify-center text-h2">Sorry!</div>
                <p class="flex justify-center">
                  An invalid token was provided to us. Try logging in and sending yourself a new
                  activation link.
                </p>
                <p class="flex justify-center">You will be redirect in {{ timer }}</p>
              </div>

              <!-- Spacers and dividers -->
              <div class="spacer"></div>
              <v-divider dark></v-divider>
              <div class="spacer"></div>

              <router-link to="/login">
                <v-btn
                  color="secondary"
                  size="large"
                  data-cy="loginFormBtn"
                  class="mt-4"
                  block
                  large
                >
                  Go to login
                </v-btn>
              </router-link>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import E6Logo from '@/assets/E6_Cube_v2.png';

export default {
  name: 'ActivateUser',

  data() {
    return {
      E6Logo,
      loading: false,
      timer: 5,
    };
  },

  computed: {
    ...mapGetters('users', ['activated', 'activating']),
  },

  mounted() {
    this.loading = true;
    const { token } = this.$route.query;

    // if token isn"t present, redirect to login
    if (token === undefined || token.length === 0) {
      this.loading = false;
      this.$router.push('/login').catch(() => {});
    } else {
      // Logout the logged in user before activating
      this.$store.dispatch('authentication/logout');

      // activate user
      this.$store
        .dispatch('users/activateMe', token)
        .then((res) => {
          this.loading = false;
          this.countdown = window.setInterval(() => {
            if (this.timer === 0) {
              this.$router.push('/dashboard').catch(() => {});
            } else {
              this.timer--;
            }
          }, 1000);
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
          this.countdown = window.setInterval(() => {
            if (this.timer === 0) {
              this.$router.push('/login').catch(() => {});
            } else {
              this.timer--;
            }
          }, 1000);
        });
    }
  },

  beforeDestroy() {
    clearInterval(this.countdown);
  },
};
</script>

<style scoped>
.activate {
  margin-top: 125px;
  display: flex;
  justify-content: center;
}

.form-container {
  max-width: 600px;
  width: 100%;
  padding: 30px;
}

.logo {
  width: 185px;
  height: 91.33px;
  margin: 20px;
}

.flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.justify-end {
  justify-content: flex-end;
}

.spacer {
  margin: 20px 0 20px 0;
}

p {
  text-align: center;
}

.title {
  margin-bottom: 25px;
}

.connect-login {
  height: 100%;
  padding: 115px 65px;
  background-color: rgba(0, 0, 0, 0.7) !important;
  transition: all 0.3s ease-in-out;
}

.logo {
  width: 125px;
  height: 144px;
  margin: 20px;
  margin-bottom: -65px;
  z-index: 20;
}

@media (min-width: 1902px) {
  .connect-login {
    padding: 115px 54px;
  }
}

@media (max-width: 600px) {
  .login {
    margin-bottom: 50px;
  }
  .connect-login {
    padding: 85px 35px 50px;
  }
  .login-box {
    margin-top: -40px;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .login-box {
    /* margin-top: -40px; */
    margin-top: 0;
    max-width: 100%;
  }
}
</style>
